<template>
    <DataHeader class="wrap-stock-table">
        <div class="dataHeaderTitle" slot="title">
            <div class="mid-wrap-title">{{title}}</div>
            <span v-if="tableData && tableData.update" class="data-date">数据日期：{{tableData.update}}</span>            
        </div>
        <div class="mid-wrap-cont" slot="cont">
            <GeminiScrollbar :minThumbSize="120">
                <table width="100%">
                    <thead>
                        <tr>
                            <th v-for="(item, index) in tableHead" 
                                :key="index"
                                @click="sortByTitle(index)"
                                :class="{'hover':index>2}">
                                <span :class="{margin2:index>2}">{{item}}</span>
                                <div v-if="index>2" class="icon-title-up" :class="{sort:index===sortIndex&&!upOrDown}"></div>
                                <div v-if="index>2" class="icon-title-down" :class="{sort:index===sortIndex&&upOrDown}"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="tableData && tableData.data">
                        <tr v-for="(item, index) in tableData.data"
                            :key="item.id"
                            @click="trClick(index, {code:item.code, market:item.market_code})"
                            @dblclick="trDbclick(item.code, item.market_code)"
                            :class="index===activeTr?'tr-active':''" >
                            <td>{{index + 1}}</td>
                            <td class="active-code">{{item.code}}</td>
                            <td>{{item.name}}</td>
                            <td :class="item.zdf>0?'up':(item.zdf<0?'down':'')">{{item.price | formatterMoney(2) | formatUnit('')}}</td>
                            <td :class="item.zdf>0?'up':(item.zdf<0?'down':'')">{{item.zdf | formatterMoney(2) | formatUnit('%')}}</td>
                            <td :class="item.inflow>0?'up':(item.inflow<0?'down':'')">{{item.inflow | formatterMoney(2)}}</td>
                            <td>{{item.buy | formatterMoney(2)}}</td>
                            <td>{{item.sell | formatterMoney(2)}}</td>
                            <td style="color:#00ffff;">{{item.cgl | formatterMoney(2) | formatUnit('')}}</td>
                            <td style="color:#00ffff;">{{item.zltbl | formatterMoney(2) | formatUnit('%')}}</td>
                        </tr>
                    </tbody>
                </table>
            </GeminiScrollbar>
        </div>
    </DataHeader>
</template>

<script>
import Axios from 'axios'
import DataHeader from '../dataHeader/dataHeader'
import { getStockList } from '../../assets/js/action'
import { sortByKey } from '../../assets/js/utils'
import event from '../event'
export default {
    props: {
        stockSelected: Number
    },
    data() {
        return {
            tableData: {},
            allData: {},
            title: '沪股通成交榜',
            tableHead: ['', '代码', '名称', '现价', '涨幅', '净买入金额', '买入额', '卖出额', '陆股通持股量', '占流通股比'],
            sortKey: ['', '', '', 'price', 'zdf', 'inflow', 'buy', 'sell', 'cgl', 'zltbl'],
            activeTr: -1,
            iconActiveIndex: 0,
            sortIndex: -1,
            upOrDown: true,
            userId: '',
            selftableData: {}
        }
    },
    mounted() {
        this.getSelfStockData()
        this.getStockListData('north')
        this.getStockListData('south')
    },
    methods: {
        getStockListData(type) {
            getStockList(type).then(data => {
                let allData = data.data
                if (type === 'north') {
                    this.allData.hgt = allData.h
                    this.allData.sgt = allData.s
                } else {
                    this.allData.ggth = allData.h
                    this.allData.ggts = allData.s
                }
                // 设置默认数据
                if (this.stockSelected === 0) {
                    this.title = '自选陆股通'
                    const selftableData = JSON.parse(window.localStorage.getItem('selftableData'))
                    if (selftableData.data && selftableData.data.length > 0) {
                        this.tableData = selftableData
                        this.activeTr = 0
                        this.tableData.data && event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                    } else {
                        this.tableData = {}
                    }
                } else if (this.stockSelected === 1) {
                    this.tableData = this.allData.hgt
                    this.activeTr = 0
                    this.title = '沪股通成交榜'
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                } else if (this.stockSelected === 2)  {
                    this.tableData = this.allData.sgt
                    this.activeTr = 0
                    this.title = '深股通成交榜'
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                } else if (this.stockSelected === 3) {
                    this.tableData = this.allData.ggth
                    this.activeTr = 0
                    this.title = '港股通(沪)成交榜'
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                } else if (this.stockSelected === 4) {
                    this.tableData = this.allData.ggts
                    this.activeTr = 0
                    this.title = '港股通(深)成交榜'
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                }
            })
        },
        getSelfStockData() { // 获取自选股数据
            Axios.get('//data.10jqka.com.cn/hsgt/self/' + '?_=' + new Date().getTime()).then(d => {
                window.localStorage.setItem('selftableData', JSON.stringify(d.data))
            });
        },
        trClick(index, info) {
            this.activeTr = index
            event.set('info', info)
            
            window.TA.log({
                id: `webhsgt_stocklist_list_click`
            })
        },
        trDbclick(code, marketid) {
            if (marketid == 177) {
                code = code.toString().split('')
                code[0] = 'HK'
                code = code.join('')
            }
            if (window.API) {
                window.API.use({
                    method: 'Quote.switchCode',
                    data: code
                });
            }
            window.TA.log({
                id: `webhsgt_stocklist_list_doubleclick`
            })
        },
        sortByTitle(index) {
            this.sortIndex = index
            this.upOrDown = !this.upOrDown
            let sortKey = this.sortKey[index]
            this.tableData.data = this.upOrDown ? 
                this.tableData.data.sort(sortByKey(sortKey)) :
                this.tableData.data.sort(sortByKey(sortKey, true))

                
            window.TA.log({
                id: `webhsgt_stocklist_list_rank`
            })
        },
         //当个股榜单切换时，个股内的股票排序顺序保持和上一个个股内的股票保持一致
        sortWithStockListChange(index){
            if(index === -1) {
                return;
            }
            const  sortKey = this.sortKey[index];
            this.tableData.data = this.upOrDown ? 
                this.tableData.data.sort(sortByKey(sortKey)) :
                this.tableData.data.sort(sortByKey(sortKey, true));
        }
    },
    watch: {
        stockSelected(val) {
            switch(val) {
                case 0:
                    this.title = '自选陆股通'
                    const selftableData = JSON.parse(window.localStorage.getItem('selftableData'))
                    if (selftableData.data && selftableData.data.length > 0) {
                        this.tableData = selftableData;
                        this.activeTr = 0
                        this.tableData.data && event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                    } else {
                        this.tableData = {}
                    }
                    break;
                case 1:
                    this.title = '沪股通成交榜'
                    this.tableHead[8] = '陆股通持股量'
                    this.tableData = this.allData.hgt
                    this.activeTr = 0
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                    break;
                case 2:
                    this.title = '深股通成交榜'
                    this.tableHead[8] = '陆股通持股量'
                    this.tableData = this.allData.sgt
                    this.activeTr = 0
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                    break;
                case 3:
                    this.title = '港股通(沪)成交榜'
                    this.tableHead[8] = '港股通持股量'
                    this.tableData = this.allData.ggth
                    this.activeTr = 0
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                    break;
                case 4:
                    this.title = '港股通(深)成交榜'
                    this.tableHead[8] = '港股通持股量'
                    this.tableData = this.allData.ggts
                    this.activeTr = 0
                    event.set('info',  {code: this.tableData.data[0].code, market: this.tableData.data[0].market_code})
                    break;
            }
             this.sortWithStockListChange(this.sortIndex);
        }
    },
    components: {
        DataHeader
    }
}
</script>

<style lang="less">
.wrap-stock-table {
    margin: 0 3px;
    .dataHeaderSign {
        margin-left: 7px;
    }
    .mid-wrap-cont {
        height: 648px;
        background: #1b1b1b;
        text-align: center;
        font-size: 12px;
        color: #aaaaaa;
        .gm-scrollbar {
            .thumb { 
                width: 8px !important;
                background: #404040 !important;
                top: 30px;
            }
        }
        .gm-scroll-view {
            width: 751px !important;
        }
        table {
            thead {
                tr {
                    background: #2a2a2a;
                    th {
                        height: 30px;
                        line-height: 30px;
                        position: relative;
                        .icon-title-up, .icon-title-down {
                            width: 0;
                            height: 0;
                            display: inline-block;
                            overflow: hidden;
                            font-size: 0;
                            line-height: 0;
                            border-width: 4px;
                            position: absolute;
                            right: 0;
                        }
                        .margin2 {
                            display: inline-block;
                            margin-right: 2px;
                        }
                        .icon-title-up {
                            top: 6px;
                            right: inherit;
                            border-style: dashed dashed solid dashed;
                            border-color: transparent transparent #aaaaaa transparent;
                            &.sort {
                                border-color: transparent transparent #109aff transparent;
                            }
                        }
                        .icon-title-down {
                            top: 15px;
                            right: inherit;
                            border-style: solid dashed dashed dashed;
                            border-color: #aaaaaa transparent transparent transparent;
                            &.sort {
                                border-color: #109aff transparent transparent transparent;
                            }
                        }
                        &.hover:hover {
                            cursor: pointer;
                        }
                    }
                }
            }
            tbody {
                tr {
                    td {
                        height: 30px;
                        line-height: 30px;
                        &.up { color: '#ff2b32'; }
                        &.down { color: '#20ad43'; }
                    }
                    &:hover {
                        background: #343434;
                    }
                    &.tr-active {
                        background: #1f2837;
                    }
                    &:hover {
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .data-date {
        position: absolute;
        right: 20px;
        font-size: 12px;
        top: 0;
        color: #d2d2d3;
    } 
}

.newblack{
    .wrap-stock-table{
        border-left: 1px solid #cbcbe1;
        border-right: 1px solid #cbcbe1;
        .mid-wrap-cont{
            background: #fff;
            color: #777;
            .gm-scrollbar{
                .thumb{
                    background: rgba(75,75,114,0.4) !important;
                }
            }
            table{
                thead{
                    tr{
                        background: #f3f3fa;
                        th{
                            .icon-title-down {
                                top: 6px;
                                right: inherit;
                                border-style: dashed dashed solid dashed;
                                border-color: transparent transparent #aaaaaa transparent;
                                &.sort {
                                    border-color: transparent transparent #1b63d9 transparent;
                                }
                            }
                            .icon-title-up {
                                top: 15px;
                                right: inherit;
                                border-style: solid dashed dashed dashed;
                                border-color: #aaaaaa transparent transparent transparent;
                                &.sort {
                                    border-color: #1b63d9 transparent transparent transparent;
                                }
                            }
                        }
                    }
                }
                tbody{
                    tr{
                        td{
                            color: rgba(39, 40, 65 0.8);
                            &.up { color: '#cd4746'; }
                            &.down { color: '#20ac2b'; }
                            &:nth-child(9){color:#272841 !important;}
                            &:nth-child(10){color:#272841 !important;}
                        }
                        &:hover {
                            background: #d4e1f8;
                        }
                        &.tr-active {
                            background: #d4e1f8;
                        }
                        
                    }
                }
            }
        }
        .data-date{
            color: #272841;
        }
    }
}

.newgrey{
    .wrap-stock-table{
        border-left: 1px solid #2e2e33;
        border-right: 1px solid #2e2e33;
        .mid-wrap-cont{
            background: #181c21;
            color: #aaa;
            .gm-scrollbar{
                .thumb{
                    background: #393941;
                }
            }
            table{
                thead{
                    tr{
                        background: #23252a;
                        th{
                            .icon-title-down {
                                top: 6px;
                                right: inherit;
                                border-style: dashed dashed solid dashed;
                                border-color: transparent transparent #aaaaaa transparent;
                                &.sort {
                                    border-color: transparent transparent #1b63d9 transparent;
                                }
                            }
                            .icon-title-up {
                                top: 15px;
                                right: inherit;
                                border-style: solid dashed dashed dashed;
                                border-color: #aaaaaa transparent transparent transparent;
                                &.sort {
                                    border-color: #1b63d9 transparent transparent transparent;
                                }
                            }
                        }
                    }
                }
                tbody{
                    tr{
                        td{
                            &.up { color: '#cd4746'; }
                            &.down { color: '#20ac2b'; }
                            &:nth-child(9){color:#fff !important;}
                            &:nth-child(10){color:#fff !important;}
                        }
                        &:hover {
                            background: #34517d;
                        }
                        &.tr-active {
                            background: #34517d;
                        }
                    }
                }
            }
        }
        .data-date{
            color: #fff;
        }
    }
}



.newclassic{
    .wrap-stock-table{
        .mid-wrap-cont{
            background: #1b1b1b;
            color: #aaaaaa;
            table{
                thead{
                    tr{
                        background: #23252a;
                        th{
                            .icon-title-down {
                                top: 6px;
                                right: inherit;
                                border-style: dashed dashed solid dashed;
                                border-color: transparent transparent #aaaaaa transparent;
                                &.sort {
                                    border-color: transparent transparent #ff2b48 transparent;
                                }
                            }
                            .icon-title-up {
                                top: 15px;
                                right: inherit;
                                border-style: solid dashed dashed dashed;
                                border-color: #aaaaaa transparent transparent transparent;
                                &.sort {
                                    border-color: #ff2b48 transparent transparent transparent;
                                }
                            }
                        }
                    }
                }
                tbody{
                    tr{
                        td{
                            &.up { color: '#ff2b32'; }
                            &.down { color: '#20ad43'; }
                            &:nth-child(9){color:#fff !important;}
                            &:nth-child(10){color:#fff !important;}
                        }
                        &.tr-active {
                            background: rgba(43, 43, 49, 0.51);
                        }
                    }
                }
            }
        }
        .data-date{
            color: #fff;
        }
    }
}



</style>
